
import Vue from 'vue'
import { DataSet, ODataService } from '@/services'
import DataTable from './DataTable.vue'
import Pager from './Pager.vue'
import PagerDisplay from './PagerDisplay.vue'
import PageSizeSelector from './PageSizeSelector.vue'

export default Vue.extend({
   name: 'PagedDataTable',
   props: {
      data: Object as () => IDataSet,
      columns: Array as () => IDataTableColumn[],
      selectable: { type: Boolean, default: false },
      selectColumn: { type: String, default: 'IsSelected' },
   },
   methods: {
      pageSizeChanged(value: number) {
         this.data.setPageSize(value)
         this.reload()
      },

      reload() {
         this.data.load()
      },
   },
   components: {
      PagerDisplay,
      Pager,
      PageSizeSelector,
      DataTable,
   },
})
